import { setDefaultValue } from 'src/app/functions/shared-functions';
import { cloneArray } from 'src/app/app.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ListPopupComponent } from './../list-popup/list-popup.component';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationComponent } from 'src/app/modules/shared/confirmation/confirmation.component';

@Component({
  selector: 'tm-select-popup',
  templateUrl: './tm-select-popup.component.html',
  styleUrls: ['./tm-select-popup.component.scss']
})
export class TmSelectPopupComponent implements OnInit {

  @Input() options;
  @Input() form_group: UntypedFormGroup;
  @Input() label;
  @Input() form_control;
  @Input() title_property = "title";
  @Input() id_property = "id";
  @Input() placeholder;
  @Input() selected_input;
  @Input() mandatory;
  @Input() show_mandatory;
  @Input() float_label;
  @Input() disabled;
  @Input() is_required;
  @Input() data;
  @Input() basic;
  @Input() master_obj;
  @Input() enable_virtual_scroll;
  @Output() fetchEntries = new EventEmitter<any>();
  @Output() selected_obj = new EventEmitter<any>();
  @Input() style;
  @Input() class_property;
  @Input() label_block;
  @Input() maxLength;
  @Input() minLength;
  @Input() maxValue;
  @Input() minValue;
  @Input() prefix_label;
  @Input() suffix_label;
  @Input() suffix_btn_label;
  @Input() suffix_btn_icon;
  @Output() suffix_btn_listner = new EventEmitter<any>();
  @Input() label_class;
  @Input() width;
  @Input() hide_label;
  @Input() design_pattern;
  @Input() container_col = 10;
  @Input() addFunc;
  @Input() toolTip;
  @Input() auto_addition;
  @Input() auto_form_control;
  @Input() label_overflow;
  @Input() auto_data;
  @Input() enable_confirmation;
  @Input() enable_confirmation_message;
  @Input() enable_confirmation_strict;
  @Input() table_records_length;
  @Input() readonly;
  @Input() default_readonly;
  @Input() strict_auto_form_control;
  @Input() disable_default_selection;
  @Input() addFunc_extra_params
  @Input() translate_options;
  @Input() donot_autoselect;
  @Input() secondary_suffix_btn;
  @Input() secondary_suffix_title;
  @Input() appearance;
  @Input() label_action_type;
  @Input() label_action_title;
  @Input() input_class;


  wait_till_content_loading: boolean = false;
  current_selection;
  filtered_value;
  a = 'asdas'
  show_list: boolean = false;
  filtered_options = [];
  @ViewChild('form', { static: true }) form;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) options_list_view: CdkVirtualScrollViewport;
  @ViewChild('hidden_input', { static: false }) hidden_input: ElementRef;
  filter_keyword_delay;

  skip;
  obj_take;
  take;
  total_count;

  search = new UntypedFormControl();
  selected_option;
  view_port: any;
  inner_height: number;
  top: number = 0;
  left: number = 0;
  arrow_key_location = 0;
  select_height;
  last_search;
  clientY;
  back_hit: boolean = false;
  dimension;
  dimension_width;
  display_overlay = 0;
  emit = true;
  delayed_keyword;
  random_id = 'tallint_select' + Math.floor((Math.random() * 10000) + 1) + Date.now();
  actual_options: any = [];
  container_width: number = 200;

  constructor(
    private change_detector_ref: ChangeDetectorRef,
    private dialog: MatDialog
  ) {

  }

  init() {
    this.actual_options = cloneArray(this.options);

    this.options = cloneArray(this.options);

    if (!this.show_list) {
      if (!this.auto_addition) {
        this.search.reset();
      }

      if (!this.form_group.get([this.form_control]).value && !this.disable_default_selection) {
        setDefaultValue(this.form_group, this.form_control, this.options, this.id_property)
        if (!this.form_group.get([this.form_control]).value) {
          if (!this.auto_addition) {
            this.search.reset();
          }
          else {
            if (!this.form_group.get([this.auto_form_control]).value || this.form_group.get([this.auto_form_control]).value == '') {
              this.search.reset();
            }
          }
        }
      }
    }

    this.filtered_options = this.options;
    if (!this.donot_autoselect && this.options && this.options.length == 1) {
      this.onSelect(this.options[0], 0)
      if (this.auto_form_control) {
        this.form_group.get([this.auto_form_control]).patchValue(this.options[0][this.title_property]);
      }
    }

    this.initializeValue();

    this.setVirtualScroll();

    if (this.disabled) {
      this.disable(this.disabled);
    }
    setTimeout(() => {
      this.wait_till_content_loading = true;
    }, 1000)
  }

  calculatePosition() {
    let top = document.getElementById(this.random_id).getBoundingClientRect().top;
    let left = document.getElementById(this.random_id).getBoundingClientRect().left;
    if (this.container_width == 200) {
      this.container_width = document.getElementById(this.random_id).offsetWidth;
      if (this.container_width <= 200) {
        this.container_width = 200;
      }
    }

    if (top > window.innerHeight / 2) {
      this.top = top - 195;
    }
    else {
      this.top = document.getElementById(this.random_id).getBoundingClientRect().top + 45;
    }
    if (left + 300 > (window.innerWidth)) {
      if (this.width) {
        this.left = window.innerWidth - 325 + 120;

      }
      else {
        this.left = window.innerWidth - 325;

      }
    }
    else {
      this.left = left;
    }
  }


  ngOnInit() {
    this.init();


  }

  ngOnChanges(ev) {
    if (ev) {
      if (ev.options && !ev.options.firstChange) {
        this.init();
      }
      if (ev.data && !ev.data.firstChange) {

        if (ev.data.currentValue || ev.data.currentValue == 0) {
          this.search.reset();
          this.selected_option = !(ev.data.currentValue) ? ev.data.currentValue : this.selected_option;
          this.initializeValue();
        }
        else {
          if (!this.auto_addition) {
            this.search.reset();
            this.selected_option = !(ev.data.currentValue) ? ev.data.currentValue : this.selected_option;
            this.initializeValue();
          }
          else {
            if (ev.auto_data && this.auto_addition) {
              this.auto_data = ev.auto_data.currentValue;
              if (ev.auto_data.firstChange) {
                this.search.setValue(ev.auto_data.currentValue);
              } else {
                this.search.setValue(ev.auto_data.currentValue);
              }
            }
            else {
              this.search.reset();
            }
            this.selected_option = !(ev.data.currentValue) ? ev.data.currentValue : null;
            this.initializeValue();
          }
        }

      }
      if (ev.data && ev.data.firstChange) {
      }

      if ((!ev.data || ev.data && !ev.data.currentValue) && ev.auto_data && this.auto_addition) {
        this.auto_data = ev.auto_data.currentValue;
        if (ev.auto_data.firstChange) {
          this.search.setValue(ev.auto_data.currentValue);
        } else {
          this.search.setValue(ev.auto_data.currentValue);
        }
      }

      if (ev.disabled) {
        this.disable(ev.disabled.currentValue)
      }
      if (ev && ev.table_records_length) {
        this.table_records_length = ev.table_records_length.currentValue;
      }
      if (ev.mandatory) {
        this.mandatory = ev.mandatory.currentValue
      }
    }

  }

  ngOnDestroy() {
  }

  disable(disable_flag) {
    if (disable_flag) {
      this.search.disable();
      this.form_group.get(this.form_control).disable();
    }
    else {
      this.search.enable();
      this.form_group.get(this.form_control).enable()
    }
  }
  suffixButtonClicked(type?) {
    if (this.addFunc) {
      try {
        if (this.addFunc_extra_params) {
          let obj = Object.assign(this.current_selection || {}, this.addFunc_extra_params);
          if (obj && type) {
            obj['type'] = type;
          }
          this.addFunc(obj);
        }
        else {
          if (this.current_selection) {
            this.current_selection['type'] = type;
            this.addFunc(this.current_selection);

          }
          else {
            this.addFunc({ type: type });
          }
        }
      }
      catch (err) {
        console.log(err)
      }
    }
    else if (this.suffix_btn_listner) {
      this.suffix_btn_listner.emit('true');
    }
  }

  clearValue(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    this.setValue(null);
  }

  showList(event) {
    try {
      if (!this.show_list) {
        // this.calculatePosition();
        // this.display_overlay = 1;
        this.show_list = true;
        // this.filtered_options = this.options;
        // this.filter();
        // setTimeout(() => {
        //   this.setClickListener();
        // }, 100)
        event.target.select();
        this.dialog.open(ListPopupComponent, {
          width: '40%',
          data: {
            list: this.options,
            id_property: this.id_property,
            title_property: this.title_property
          }
        }).afterClosed().subscribe(res => {

          console.log(res)
          this.wait_till_content_loading = false;
          if (res) {
            this.onSelect(res.option, res.index)
          }
          setTimeout(() => {
            this.wait_till_content_loading = true;
            this.show_list = false;
          }, 500)

        })
        // this.hidden_input.nativeElement.focus();
      }
    } catch (error) {

    }
    return true;
  }

  setClickListener() {
    document.onclick = (ev) => {
      this.hideList(ev);

    }
  }

  destroyClickListener() {
    document.onclick = null;
  }

  checkForTab(ev) {
    if (ev.key == 'Tab') {
      this.hideList();
    }
  }


  searchKeyPress(event) {
    switch (event.keyCode) {
      case 38: //up-arrow
        this.moveInList(-1);
        break;

      case 40: //down-arrow
        this.moveInList(1);
        break;

      case 13: //enter
        {
          if (this.show_list) {
            if (this.filtered_options && this.filtered_options[this.arrow_key_location]) {
              this.onSelect(this.filtered_options[this.arrow_key_location], this.arrow_key_location);
            }
          }
        }
        break;

      case 9: //tab
        // this.hideList();
        break;

      case 27: //escape
        this.hideList();
        break;

      default: //other keys
        this.filter(event);
    }
  }

  filter(event?) {
    this.showList(event);
    let filter = this.search && this.search.value ? this.search.value.toLowerCase() : '';
    this.delayed_keyword = filter;

    if (this.enable_virtual_scroll) {
      if (!this.filter_keyword_delay) {
        this.getMasters(0, 1000, filter);
      }
      // this.getMasters(0, 0, filter);
    }
    else {
      if (filter) {
        this.filtered_options = [];
        for (let i = 0; i < this.options.length; i++) {
          let option = this.options[i];
          if (option && option[this.title_property]) {
            if ((option[this.title_property]).toString().toLowerCase().indexOf(filter) > -1) {
              this.filtered_options.push(option);
            }
          }
        }
        if (this.auto_addition && (this.filtered_options.length == 0 || this.strict_auto_form_control)) {
          this.form_group.get(this.form_control).setValue(null);
          if (this.auto_form_control && this.form_group.get(this.auto_form_control)) {
            this.form_group.get(this.auto_form_control).setValue(this.search.value);
            let obj = {}
            obj[this.id_property] = 0;
            obj[this.title_property] = this.search.value;

            this.search.patchValue(this.search.value);
            this.current_selection = obj
            this.selected_obj.emit(obj);
          }
          if (!this.strict_auto_form_control) {
            this.form_group.controls[this.form_control].patchValue(0)
          }
        }
      }
      else {
        this.filtered_options = this.options;
      }
    }
  }

  moveInList(val) {
    this.arrow_key_location = this.arrow_key_location + val;

    if (this.arrow_key_location >= this.filtered_options.length) {
      this.arrow_key_location = this.filtered_options.length - 1;
    }
    else if (this.arrow_key_location <= 0) {
      this.arrow_key_location = 0;
    }
    if (this.options_list_view) {
      this.options_list_view.scrollToIndex(this.arrow_key_location);
    }
  }

  hideList(ev?) {
    if (this.show_list && !ev || !(ev && document.getElementById(this.random_id) && (document.getElementById(this.random_id).contains(ev['relatedTarget']) || document.getElementById(this.random_id).contains(ev['target'])))) {
      this.show_list = false;
      if (this.selected_option) {
        this.search.setValue(this.selected_option[this.title_property])
      }
      else {

        if (!this.auto_addition) {
          this.search.reset();
          // this.form_group.get(this.form_control).setValue(null);
          // if (this.auto_form_control && this.form_group.get(this.auto_form_control)) {
          //   this.form_group.get(this.auto_form_control).setValue(this.search.value);
          //   let obj = {}
          //   obj[this.id_property] = 0;
          //   obj[this.title_property] = this.search.value
          //   this.selected_obj.emit(obj);
          // }
        }

        // this.form_group.get(this.form_control).reset();
        // this.search.markAsTouched();
        // this.search.markAsDirty();
        // this.form_group.get(this.form_control).markAsDirty();
        // this.form_group.get(this.form_control).markAsTouched();
      }
      this.display_overlay = 0;
      this.form_group.get([this.form_control]).markAsTouched();

      this.destroyClickListener();
      this.change_detector_ref.detectChanges();
    }
  }

  onSelect(selected_option, index) {
    this.arrow_key_location = index;
    if (this.enable_confirmation) {

      if (this.enable_confirmation_strict && this.table_records_length > 0) {
        this.dialog
          .open(ConfirmationComponent, {
            width: "480px",
            height: "auto",
            panelClass: "icr-dialog",
            data: {
              title: "ERROR.confirmation",
              message: this.enable_confirmation_message,
              positive_button: "BTN.yes",
              negative_button: "BTN.no"
            },
          })
          .afterClosed()
          .subscribe((res) => {
            if (res) {
              if (this.filtered_options) {
                this.setValue(selected_option);
                //hide list after selection of an option
              }

            }
            else {
              this.setValue(selected_option, 1);
            }
            this.hideList();
          });
      }
      else if (!this.enable_confirmation_strict) {
        this.dialog
          .open(ConfirmationComponent, {
            width: "480px",
            height: "auto",
            panelClass: "icr-dialog",
            data: {
              title: "ERROR.confirmation",
              message: this.enable_confirmation_message,
              positive_button: "BTN.yes",
              negative_button: "BTN.no"
            },
          })
          .afterClosed()
          .subscribe((res) => {
            if (res) {
              if (this.filtered_options) {
                this.setValue(selected_option);
                //hide list after selection of an option
              }

            }
            this.hideList();
          });
      }
      else {
        if (this.filtered_options) {
          this.setValue(selected_option);
          //hide list after selection of an option
        }
        this.hideList();
      }

    }
    else {
      if (this.filtered_options) {
        this.setValue(selected_option);
        //hide list after selection of an option
      }
      this.hideList();

    }


  }

  setValue(selected_option, doNotEmit?) {
    if (selected_option != this.selected_option) {
      this.selected_option = selected_option;
      this.current_selection = selected_option;
      if (doNotEmit) {
        if (selected_option) {
          selected_option['noChanges'] = 1;
        }
        else {
          selected_option = {}
          selected_option['noChanges'] = 1;
        }
      }
      else {
        if (selected_option) {
          selected_option['noChanges'] = 0;
        }
        else {
          selected_option = {}
          selected_option['noChanges'] = 0;
        }
      }

      if (selected_option) {
        this.form_group.get(this.form_control).setValue(selected_option[this.id_property]);
        this.search.setValue(selected_option[this.title_property]);
        if (this.auto_form_control && this.auto_form_control != '') {
          this.form_group.controls[this.auto_form_control].patchValue(selected_option[this.title_property]);
        }
      }
      else {
        this.form_group.get(this.form_control).setValue(null);
        this.search.setValue(null);
      }
      this.selected_obj.emit(selected_option);

    }
  }

  initializeValue() {
    // this.search.reset();
    // this.selected_option = null;
    let found = 0;
    if (this.filtered_options && this.form_group.get([this.form_control]).value) {
      for (let index = 0; index < this.filtered_options.length; index++) {
        let element = this.filtered_options[index];
        if (element[this.id_property] == this.form_group.get([this.form_control]).value) {
          this.search.setValue(element[this.title_property]);
          this.setValue(element);
          this.selected_option = element;
          this.arrow_key_location = index;
          found = 1;
          break;
        }
      }
    }
    if (!found) {
      for (let index = 0; index < this.actual_options.length; index++) {
        let element = this.actual_options[index];
        if (element[this.id_property] == this.form_group.get([this.form_control]).value) {
          this.search.setValue(element[this.title_property]);
          this.setValue(element);
          this.selected_option = element;
          this.arrow_key_location = index;
          found = 1;
          break;
        }
      }
    }
    // if (!found) {
    //   this.setValue(null);
    // }
  }

  onSelectNone(ev) {
    this.show_list = false;
  }

  getMasters(skip, take, search) {
    search = search ? search : '';
    // search = search ? search : '';
    this.filter_keyword_delay = true;
    setTimeout(() => {
      this.fetchEntries.emit({ 'skip': skip, 'take': take, 'search': this.delayed_keyword || '' });
      this.filter_keyword_delay = false;
    }, 900);
    setTimeout(() => {
      this.emit = true;
    }, 1000)

  }

  getNextBatch(e) {
    ////console.loge);
    if (this.enable_virtual_scroll) {
      if (e > 0) {
        if (this.emit) {
          if (e >= Math.floor(this.options.length * 0.99)) {
            if (this.take <= this.total_count) {
              this.skip = this.take + 1;
              this.getMasters(this.skip, this.master_obj.take, this.search.value);
              this.take += this.master_obj.take;
              this.emit = false;
            }
          }
        }
      }
    }
  }

  setVirtualScroll() {
    if (this.enable_virtual_scroll) {
      if (this.master_obj && this.master_obj.take) {
        const obj_take = this.master_obj.take;
        this.take = obj_take;
        this.total_count = this.master_obj.totalcount;
      }
      else {
        this.take = 100;
      }
    }
  }

}

